/* ============================================================
   DillySocks — "Dilly Surprise" Socken-Abo PDP
   Verbindet Style x Grösse (Shopify-Variante) mit der Laufzeit
   (Seal Selling Plan) und aktualisiert Preise live.
   Alle Preise kommen aus Shopify (selling_plan_allocations),
   nichts ist fest einprogrammiert.

   Wird als type="module" geladen: nur so ist der Import verfügbar, mit dem
   Horizon nach dem Warenkorb-Add den Cart-Drawer/Bubble aktualisiert. Ohne den
   Import blieb der Warenkorb bis zum Reload leer.
   ============================================================ */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  var root = document.querySelector('[data-ds-abo]');
  if (!root || root.dataset.dsAboReady === '1') return;
  root.dataset.dsAboReady = '1';

  var dataEl = root.querySelector('[data-ds-abo-data]');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variants = DATA.variants || [];
  if (!variants.length) return;

  // Übersetzte Strings aus dem JSON-Block, den ds-abo-pdp.liquid rendert
  // (dieses Asset ist ein statisches <script src>, kein {% javascript %}-Tag).
  var I18N_EL = root.querySelector('[data-ds-abo-i18n]');
  var I18N = I18N_EL ? JSON.parse(I18N_EL.textContent) : {};
  function fmt(str, vars) {
    return (str || '').replace(/\[\[(\w+)\]\]/g, function (_, key) {
      return vars && key in vars ? vars[key] : '';
    });
  }

  var styleBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ds-abo-style]'));
  var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ds-abo-size]'));
  var planBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ds-abo-plan]'));

  var submitBtn = root.querySelector('[data-ds-abo-submit]');
  var submitLabel = root.querySelector('[data-ds-abo-submit-label]');
  var stickyPrice = root.querySelector('[data-ds-abo-sticky-price]');

  var elTotal = root.querySelector('[data-ds-abo-total]');
  var elWas = root.querySelector('[data-ds-abo-was]');
  var elSave = root.querySelector('[data-ds-abo-save]');
  var elCaption = root.querySelector('[data-ds-abo-caption]');
  var elStyleLabel = root.querySelector('[data-ds-abo-style-label]');

  /* ---------- Preis-Formatierung: Format + Waehrung des aktiven Markts
     (window.dsMoney aus snippets/ds-market.liquid) ---------- */
  function formatMoney(cents) {
    if (typeof window.dsMoney === 'function') return window.dsMoney(cents);
    var m = window.DS_MARKET || {};
    return (cents / 100).toFixed(2) + ' ' + (m.currency || '');
  }

  /* ---------- Zustand ---------- */
  var state = {
    style: styleBtns.length ? styleBtns[0].dataset.dsAboStyle : null,
    size: sizeBtns.length ? sizeBtns[0].dataset.dsAboSize : null,
    plan: planBtns.length ? planBtns[0].dataset.dsAboPlan : null
  };

  function findVariant(style, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((style === null || v.style === style) && (size === null || v.size === size)) return v;
    }
    return null;
  }

  /* Grössen, die es für den gewählten Style gar nicht gibt, ausgrauen. */
  function refreshAvailability() {
    sizeBtns.forEach(function (btn) {
      var v = findVariant(state.style, btn.dataset.dsAboSize);
      var ok = !!(v && v.available);
      btn.disabled = !ok;
    });
  }

  function planMeta(planId) {
    var btn = planBtns.filter(function (b) {
      return b.dataset.dsAboPlan === planId;
    })[0];
    if (!btn) return { deliveries: 1, pairs: 1, discount: 0 };
    return {
      deliveries: parseInt(btn.dataset.deliveries, 10) || 1,
      pairs: parseInt(btn.dataset.pairs, 10) || 1,
      discount: parseFloat(btn.dataset.discount) || 0
    };
  }

  function render() {
    // Pillen-Status
    styleBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.dsAboStyle === state.style));
    });
    sizeBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.dsAboSize === state.size));
    });
    planBtns.forEach(function (b) {
      var on = b.dataset.dsAboPlan === state.plan;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-checked', String(on));
    });

    if (elStyleLabel) {
      var sb = styleBtns.filter(function (b) {
        return b.dataset.dsAboStyle === state.style;
      })[0];
      elStyleLabel.textContent = sb ? '— ' + sb.dataset.label : '';
    }

    refreshAvailability();

    var variant = findVariant(state.style, state.size);

    // Falls die Grösse für diesen Style nicht existiert: erste verfügbare nehmen.
    if (!variant || !variant.available) {
      var fallback = variants.filter(function (v) {
        return v.style === state.style && v.available;
      })[0];
      if (fallback) {
        state.size = fallback.size;
        variant = fallback;
        sizeBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.dsAboSize === state.size));
        });
      }
    }

    if (!variant) return;

    // Preise je Laufzeit für DIESE Variante nachziehen
    planBtns.forEach(function (b) {
      var alloc = variant.plans[b.dataset.dsAboPlan];
      var priceEl = b.querySelector('[data-ds-abo-plan-price]');
      if (alloc && priceEl) priceEl.textContent = formatMoney(alloc.price);
    });

    var alloc = variant.plans[state.plan];
    if (!alloc) return;

    var meta = planMeta(state.plan);
    var totalPairs = meta.pairs;

    // Zusammenfassung
    if (elTotal) elTotal.textContent = formatMoney(alloc.price);

    // Vergleichspreis = ECHTER Einzelkaufwert (Paar-Einzelpreis aus dem
    // Editor x Paare) x Lieferungen — nicht der Variantenpreis, der ist nur
    // Seals interne Rechengroesse (50.00 statt 3 x 16.90 = 50.70; Sean 13.08.).
    // Fallback auf den Variantenpreis, falls kein Einzelpreis gepflegt ist.
    var fullPerDelivery = DATA.fullPerDelivery > 0 ? DATA.fullPerDelivery : variant.price;
    var fullPrice = fullPerDelivery * meta.deliveries;
    if (elWas) {
      if (fullPrice > alloc.price) {
        elWas.textContent = formatMoney(fullPrice);
        elWas.hidden = false;
      } else {
        elWas.textContent = '';
        elWas.hidden = true;
      }
    }
    // Rabatt-Prozent ebenfalls gegen den echten Einzelkauf gerechnet
    var savePct = fullPrice > 0 ? Math.round(100 - (alloc.price / fullPrice) * 100) : 0;
    if (elSave) {
      if (savePct > 0) {
        elSave.textContent = '−' + savePct + '%';
        elSave.hidden = false;
      } else {
        elSave.hidden = true;
      }
    }

    if (elCaption) {
      var perPair = totalPairs > 0 ? formatMoney(Math.round(alloc.price / totalPairs)) : '';
      if (meta.deliveries === 1) {
        elCaption.textContent = fmt(I18N.caption.recurring, { price: formatMoney(alloc.price), per_pair: perPair });
      } else {
        elCaption.textContent = fmt(I18N.caption.oneTime, { deliveries: meta.deliveries, per_pair: perPair });
      }
    }

    if (stickyPrice) stickyPrice.textContent = formatMoney(alloc.price);

    current = variant;
    if (submitBtn) submitBtn.disabled = !variant.available;
  }

  /* ---------- In den Warenkorb (Cart-AJAX, mit selling_plan) ---------- */
  var current = null;
  var busy = false;

  async function addToCart() {
    if (busy || !current || !state.plan) return;
    busy = true;

    var original = submitLabel ? submitLabel.textContent : '';
    if (submitLabel) submitLabel.textContent = I18N.cart.adding;
    if (submitBtn) submitBtn.disabled = true;

    var line = { id: current.id, quantity: 1, selling_plan: Number(state.plan) };

    // Horizon über den Warenkorb informieren (Cart-Drawer aktualisiert sich).
    var deferred = null;
    if (typeof CartLinesUpdateEvent !== 'undefined') {
      deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: line.id, quantity: 1 }],
          promise: deferred.promise
        })
      );
    }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      });
      if (!res.ok) throw new Error('Cart add failed');

      if (deferred) {
        var cart = await (await fetch('/cart.js')).json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, itemCount: cart.item_count, didError: false }
        });
      }

      if (submitLabel) submitLabel.textContent = I18N.cart.added;
      setTimeout(function () {
        if (submitLabel) submitLabel.textContent = original;
        if (submitBtn) submitBtn.disabled = false;
        busy = false;
      }, 2500);
    } catch (e) {
      if (deferred) deferred.resolve({ detail: { didError: true } });
      if (submitLabel) submitLabel.textContent = I18N.cart.error;
      if (submitBtn) submitBtn.disabled = false;
      busy = false;
    }
  }

  /* ---------- Events ---------- */
  styleBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.style = b.dataset.dsAboStyle;
      render();
    });
  });
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      state.size = b.dataset.dsAboSize;
      render();
    });
  });
  planBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.plan = b.dataset.dsAboPlan;
      render();
    });
  });

  if (submitBtn) submitBtn.addEventListener('click', addToCart);

  /* ---------- Galerie-Punkte (Mobile-Swipe) ---------- */
  var gallery = root.querySelector('[data-ds-abo-gallery]');
  if (gallery) {
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.ds-abo__gdot'));
    gallery.addEventListener(
      'scroll',
      function () {
        if (!gallery.clientWidth) return;
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) {
          d.setAttribute('data-active', String(i === idx));
        });
      },
      { passive: true }
    );
  }

  /* ---------- Style-Karten / Geschenk-Button: zum Konfigurator springen ---------- */
  var config = root.querySelector('[data-ds-abo-config]');
  document.addEventListener('click', function (ev) {
    var jump = ev.target.closest ? ev.target.closest('[data-ds-abo-jump]') : null;
    if (!jump) return;

    var wanted = jump.getAttribute('data-ds-abo-jump');
    if (wanted) {
      var match = styleBtns.filter(function (b) {
        return b.dataset.dsAboStyle === wanted;
      })[0];
      if (match) {
        state.style = wanted;
        render();
      }
    }

    // Scroll-Ziel je nach Layout:
    // - Desktop: die Kaufbox klebt (position: sticky). Ihre aktuelle
    //   (festgeklebte) Position taugt nicht als Ziel -> stattdessen das
    //   nicht-klebende Haupt-Grid anfahren; die Kaufbox erscheint dann oben.
    // - Mobile: der Konfigurator liegt im normalen Fluss -> direkt dorthin.
    // Bewusst scrollIntoView statt window.scrollTo({behavior:'smooth'}): letzteres
    // hat sich auf Desktop als unzuverlässig erwiesen (Seite blieb stehen).
    // Der Header-Versatz kommt über scroll-margin-top (CSS) auf den Zielen.
    var buyBox = root.querySelector('.ds-abo__buy');
    var isSticky = buyBox && window.getComputedStyle(buyBox).position === 'sticky';
    var target = isSticky ? (root.querySelector('.ds-abo__main') || config || root) : (config || root);
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  render();
})();

/* ============================================================
   FAQ-Akkordeon (eigene Sektion, unabhängig vom Konfigurator)
   ============================================================ */
(function () {
  'use strict';

  var faq = document.querySelector('[data-ds-abo-faq]');
  if (!faq || faq.dataset.dsFaqReady === '1') return;
  faq.dataset.dsFaqReady = '1';

  faq.addEventListener('click', function (ev) {
    var btn = ev.target.closest('.ds-abo-faq__q');
    if (!btn) return;

    var item = btn.closest('.ds-abo-faq__item');
    var isOpen = item.getAttribute('data-open') === 'true';

    // Immer nur einen Eintrag offen lassen.
    faq.querySelectorAll('.ds-abo-faq__item').forEach(function (el) {
      el.setAttribute('data-open', 'false');
      var q = el.querySelector('.ds-abo-faq__q');
      var ic = el.querySelector('.ds-abo-faq__q i');
      if (q) q.setAttribute('aria-expanded', 'false');
      if (ic) ic.className = 'fa-solid fa-plus';
    });

    if (!isOpen) {
      item.setAttribute('data-open', 'true');
      btn.setAttribute('aria-expanded', 'true');
      var icon = btn.querySelector('i');
      if (icon) icon.className = 'fa-solid fa-xmark';
    }
  });
})();
